import { ISearchBox } from "@fluentui/react";
import { useEffect, useRef, useState } from "react";
import { IFilterListaHazardRequest, IListaHazard, IListaHazardRequest } from "../../../Interfaces/hazard/IHazard";
import { IPaginationV2 } from "../../../Interfaces/base/ITable";
import { HazardService } from "../../../services/hazard/hazardService";
import { formatGuionFecha } from "../../../utils/helpers/dateHelpers";

export const UseTablaHazard=()=>{
    const [loading, setLoading] = useState<boolean>(false);
    const [items, setItems] = useState<IListaHazard[]>([]);
    const onChangeSearch = useRef<ISearchBox>(null);
    const [control, setControl] = useState(true);
    const initial: IListaHazardRequest = {
        skip: 0,
        take: 50
    };
    const [filter, setFilter] = useState<IListaHazardRequest>(initial);
    const [filterElement,setFilterElement]=useState<IFilterListaHazardRequest>({})
    const _onkeyUpSearchTable = (event: React.KeyboardEvent<HTMLInputElement>) => {
        let { value } = event.target as HTMLInputElement;
        setFilter({ ...filter, search: value });
        setControl(true);
    };
    const [loadReporte,setLoadReporte]=useState<boolean>(false)
    const onChangeTake = (value: number) => {
        setFilter({ ...filter, take: value });
        setControl(true);
    };

    const onSkip = (value: number) => {
        const realSkip = (value * filter.take) - filter.take;
        setFilter({ ...filter, skip: realSkip });
        setControl(true);
    };
    const [pagination, setPagination] = useState<IPaginationV2>({
        currentPage: 0,
        total: 0,
        pageSize: 0,
        skip: 0,
        take: 50,
        onPageChange: onSkip,
        onSizeChange: onChangeTake
    });
    const handleResetUpdate = () => {
        setFilter(initial);
        setControl(true);
    };
    const getListaRegistros=()=>{
        setLoading(true)
            HazardService.ListarFormularios(filter)
            .then((res) => {
                const pag: IPaginationV2 = {
                    currentPage: res.data.page,
                    total: res.data.total,
                    pageSize: res.data.pages,
                    onPageChange: onSkip,
                    skip: filter.skip,
                    take: filter.take,
                    onSizeChange: onChangeTake
                };
                setPagination(pag);
                setLoading(false);
                setItems(res.data.items);
            })
            .catch((e: any) => {
                setLoading(false);
            });
    }
    useEffect(() => {
        if (control) {
            getListaRegistros();
            setControl(false);
        }
    }, [control]);
    const buscar = () => {
        const {incidenteKey,elementoEstandarKey,condicionInseguraKey,actoInseguroKey,fechaInicio,fechaFin} = filterElement
        setFilter({...filter,incidenteId:incidenteKey,elementoEstandarId:elementoEstandarKey,condicionInseguraId:condicionInseguraKey,actoInseguroId:actoInseguroKey,
        fechaDesde:fechaInicio!=undefined? formatGuionFecha(fechaInicio,false) : undefined,
        fechaHasta:fechaFin!=undefined? formatGuionFecha(fechaFin,true) : undefined})
        setControl(true);
    }
    const ResetFilter =()=>{
        setFilter({
            skip: 0,
            take: 50,
            search: "",
        })
        setFilterElement({})
    }

    const descargarReporte = () => {
        setLoadReporte(true)
        HazardService.CargaReporteFormularioHazard({})
            .then((res) => {
                if (res.status == 200) {
                    const url = window.URL.createObjectURL(new Blob([res.data]))
                    const link = document.createElement("a");
                    link.href = url;
                    setLoadReporte(false)
                    link.setAttribute("download", "ReporteRegistroFormularioHazard.xlsx");
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    console.log("DESCARGA EXITOSA")
                }
            })
            .catch(e => {
                setLoadReporte(false)
            })
    }
    return {
        
        items,
        filter,
        setFilter,
        loading,
        pagination,
        handleResetUpdate,
        onChangeSearch,
        onChangeTake,
        _onkeyUpSearchTable,
        getListaRegistros,
        setControl,
        buscar,ResetFilter,filterElement,setFilterElement,descargarReporte,loadReporte
    };
}